const emoji = [
  {
    value: '0',
    title: '捶地',
  },
  {
    value: '1',
    title: '怀疑',
  },

  {
    value: '2',
    title: '撇嘴',
  },
  {
    value: '3',
    title: '色',
  },
  {
    value: '4',
    title: '发呆',
  },
  {
    value: '5',
    title: '酷',
  },
  {
    value: '6',
    title: '害羞',
  },

  {
    value: '7',
    title: '闭嘴',
  },
  {
    value: '8',
    title: '睡觉',
  },
  {
    value: '9',
    title: '大哭',
  },
  {
    value: '10',
    title: '尴尬',
  },
  {
    value: '11',
    title: '发怒',
  },
  {
    value: '12',
    title: '调皮',
  },
  {
    value: '13',
    title: '呲牙',
  },
  {
    value: '14',
    title: '微笑',
  },
  {
    value: '15',
    title: '难过',
  },
  {
    value: '16',
    title: '帅呆',
  },
  {
    value: '17',
    title: '折磨',
  },
  {
    value: '18',
    title: '吐',
  },
  {
    value: '19',
    title: '偷笑',
  },
  {
    value: '20',
    title: '可爱',
  },
  {
    value: '21',
    title: '白眼',
  },
  {
    value: '22',
    title: '傲慢',
  },
  {
    value: '23',
    title: '嘴馋',
  },
  {
    value: '24',
    title: '困',
  },
  {
    value: '25',
    title: '恐慌',
  },
  {
    value: '26',
    title: '流汗',
  },
  {
    value: '27',
    title: '憨笑',
  },
  {
    value: '28',
    title: '大兵',
  },
  {
    value: '29',
    title: '奋斗',
  },
  {
    value: '30',
    title: '疑问',
  },
  {
    value: '31',
    title: '嘘',
  },
  {
    value: '32',
    title: '晕',
  },
  {
    value: '33',
    title: '被炸了',
  },
  {
    value: '34',
    title: '骷髅',
  },
  {
    value: '35',
    title: '敲打',
  },
  {
    value: '36',
    title: '拜拜',
  },
  {
    value: '37',
    title: '发抖',
  },
  {
    value: '38',
    title: '亲密',
  },
  {
    value: '39',
    title: '跳',
  },
  {
    value: '40',
    title: '猪头',
  },
  {
    value: '41',
    title: '拥抱',
  },
  {
    value: '42',
    title: '生日蛋糕',
  },
  {
    value: '43',
    title: '闪电',
  },
  {
    value: '44',
    title: '地雷',
  },
  {
    value: '45',
    title: '刀',
  },
  {
    value: '46',
    title: '足球',
  },
  {
    value: '47',
    title: '便便',
  },
  {
    value: '48',
    title: '咖啡',
  },
  {
    value: '49',
    title: '米饭',
  },
  {
    value: '50',
    title: '玫瑰',
  },
  {
    value: '51',
    title: '枯萎玫瑰',
  },
  {
    value: '52',
    title: '爱心',
  },
  {
    value: '53',
    title: '心碎',
  },
];

export const prefixUrl = 'https://a.links123.cn/site/src/feed/imgs/qq/';

export const ext = 'gif';

export default emoji;
